import { cn } from "@/lib/utils";

// Official MR Solutions wordmark (extracted from the brand asset, white knocked out
// to transparent). Navy variant for light scenes; white variant for dark contexts.
const SRC = {
  navy: { src: `${process.env.PUBLIC_URL || ""}/mr-logo.png`, width: 600, height: 417 },
  white: { src: `${process.env.PUBLIC_URL || ""}/mr-logo-white.png`, width: 600, height: 417 },
};

export const MRLogo = ({ className = "", variant = "navy", title = "MR Solutions" }) => {
  const asset = SRC[variant] || SRC.navy;
  return (
    <img
      src={asset.src}
      alt={title}
      width={asset.width}
      height={asset.height}
      draggable={false}
      className={cn("h-auto max-w-full select-none", className)}
    />
  );
};
